import styled from 'styled-components';
import { brand } from 'styles/Colors';

export const AutocompleteWrapper = styled.div`
  .MuiInputLabel-root.Mui-focused {
    color: ${brand};
  }
`;
